import { REACT_APP_API } from 'cfgCommon/config'
import axios from 'axios'

export const addFileWhenCreate = async (files, id, body, isUsed = false) => {
  try {
    let response = null
    if (isUsed) {
      for (let file of files) {
        response = await axios.post(
          REACT_APP_API + '/files/' + file.id + '/associations',
          body
        )
      }
    } else {
      const filesForId = files[id]
      for (let index in filesForId) {
        const item = filesForId[index]
        response = await axios.post(
          REACT_APP_API + '/files/' + item.id + '/associations',
          body
        )
      }
    }
    return response
  } catch (err) {
    return err
  }
}
